<template>
  <div id="app">
    <NavigationBarAnonymous />
    <NavigationBar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Footer from '@/components/layout/Footer.vue'
import NavigationBar from '@/components/layout/NavigationBar.vue'
import NavigationBarAnonymous from '@/components/layout/NavigationBarAnonymous.vue'

import KeycloakInstance from '@/plugins/KeycloakInstance.js'

export default {
  name: 'App',
  components: {
    Footer,
    NavigationBar,
    NavigationBarAnonymous
  },
  computed: {
    isIdle () {
      return this.$store.state.idleVue.isIdle
    }
  },
  methods: {
    ...mapActions([
      'acceptAuthentication',
      'setLocale'
    ]),
    ...mapGetters([
      'getAuthorizationStatus'
    ])
  },
  created () {
    this.$i18n.locale = localStorage.getItem('locale') || this.$i18n.locale
    this.setLocale(this.$i18n.locale)

    // If we are authorized with Keycloak.js but Vue is unaware
    // TODO: Figure a way to handle this in a promise in the authenticate action
    //       Currently fails because of the keycloak redirection.
    if ((this.getAuthorizationStatus() !== 'success') &&
         KeycloakInstance.isAuth()) {
      this.acceptAuthentication()
    }
  },
  watch: {
    isIdle: function (value) {
      if (value) {
        location.reload()
      }
    }
  }
}
</script>

<style lang="scss">
// https://stackoverflow.com/questions/51516084/how-do-i-add-a-google-font-to-a-vuejs-component
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');
html, body {
  font-family: 'Roboto', sans-serif;
}
#app {
  font-family: 'Roboto', sans-serif;
}
.select select optgroup {
  color: #363636 !important;
}
.disclaimer {
  padding-left: 40px;
  padding-top: 40px;
  padding-right: 40px;
  font-size: small;
}

// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #29398A;
$primary-invert: findColorInvert($primary);
$secondary: #813B8E;
$secondary-invert: findColorInvert($secondary);
$tertiary: #298A7A;
$tertiary-invert: findColorInvert($tertiary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);
$danger: #B22222;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": ($white, $black),
  "black": ($black, $white),
  "light": ($light, $light-invert),
  "dark": ($dark, $dark-invert),
  "primary": ($primary, $primary-invert),
  "secondary": ($secondary, $secondary-invert),
  "tertiary": ($tertiary, $tertiary-invert),
  "info": ($info, $info-invert),
  "success": ($success, $success-invert),
  "warning": ($warning, $warning-invert),
  "danger": ($danger, $danger-invert),
  "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
